<template>
  <div class="toughening-view-container">
    <div class="furnace-main-view">
      <TougheningBatchBar :tougheningBatch="productionStation.tougheningBatch" :loadingBedPanelCount="loadBedPanelList.length" @click="tougheningBarClicked" />

      <div class="furnace-view" @click="focusBarcodeEntry()">
        <StationAlertMessage ref="alertMessage" />
        
        <div class="station-scanner-entry mt-4" v-show="(scanInAvailable && isLoadingBedSelected) || (scanOutAvailable && isTougheningBedSelected)">
          <h2 class="text-muted" v-if="isLoadingBedSelected">Enter panel barcode to scan in a panel for {{productionStage.name}}</h2>
          <h2 class="text-muted" v-if="isTougheningBedSelected">Enter panel barcode to scan out a panel for {{productionStage.name}}</h2>
          <div class="row">
            <div class="col-8">
              <FormInputText ref="panelBarcodeScan" v-model="barcodeEntry" placeholder="Barcode" @enter="onScannedBarcode" prependSlot>
                <template v-slot:prepend>
                  <i class="far fa-scanner"></i>
                </template>
              </FormInputText>
            </div>
            <div class="col-4">
              <div class="furnace-options float-right">
                <StationControlPanelButton class="btn-default" sizeClass="xl" iconStyle="fal" icon="fa-scanner-keyboard" @click="scanOptionsClicked">Scan Options</StationControlPanelButton>
                <div class="mr-2" />
                <StationControlPanelButton class="btn-success" sizeClass="xl" iconStyle="fal" icon="fa-plus-square" @click="newSampleButtonClicked" v-if="isLoadingBedSelected && selectedBedSampleCount == 0">New Sample</StationControlPanelButton>
                <StationControlPanelButton class="btn-danger" sizeClass="xl" iconStyle="fal" icon="fa-times" @click="removeBatchSample" v-if="(isLoadingBedSelected || isTougheningBedSelected) && selectedBedSampleCount > 0">Remove Sample</StationControlPanelButton>
                <div class="mr-2" />
                <StationControlPanelButton class="btn-success" sizeClass="xl" iconStyle="fal" icon="fa-clipboard-list-check" @click="createNewBatch" v-if="isLoadingBedSelected || isTougheningBedSelected">New Batch</StationControlPanelButton>
              </div>
            </div>
          </div>
        </div>

        <br />

        <template v-if="isLoadingBedSelected">
          <div>
            <h2>Loading Bed Panels</h2>
          </div>
          <div class="station-list-container">
            <div ref="loadingQueueList" class="station-list station-thumb-layout">
              <QueuePanelThumbItem
                v-for="panel of loadBedPanelList"
                :key="panel.id"
                :panel="panel"
                :highlightColour="productionStage.highlightColour"
                :currentStationId="productionStation.id"
                :queueDisplayType="productionStation.queueDisplayType"
                :ref="`panel-queue-${panel.id}`"
                @previewClicked="queuePanelPreviewClicked($event, panel)"
                @panelClicked="queuePanelClicked($event, panel)"
                @removePanel="removePanelFromStation(panel.id)">
              </QueuePanelThumbItem>
            </div>
            <h2 class="text-muted text-center" v-if="loadBedPanelList.length == 0">No panels on loading bed</h2>
          </div>
        </template>

        <template v-if="isWaitingBatchBedSelected">
          <div>
            <h2>Waiting Batch Bed Panels</h2>
          </div>
          <div class="station-list-container">
            <div class="station-list station-thumb-layout">
              <QueuePanelThumbItem
                v-for="panel of waitingBatchBedPanelList"
                :key="panel.id"
                :panel="panel"
                :highlightColour="productionStage.highlightColour"
                :currentStationId="productionStation.id"
                :queueDisplayType="productionStation.queueDisplayType"
                :ref="`panel-queue-${panel.id}`"
                @previewClicked="queuePanelPreviewClicked($event, panel)"
                @panelClicked="queuePanelClicked($event, panel)"
                @removePanel="removePanelFromStation(panel.id)">
              </QueuePanelThumbItem>
            </div>
            <h2 class="text-muted text-center" v-if="waitingBatchBedPanelList.length == 0">No panels on waiting batch bed</h2>
          </div>
        </template>

        <template v-if="isTougheningBedSelected">
          <div>
            <h2>Unloading Bed Panels</h2>
          </div>
          <div class="station-list-container">
            <div class="station-list station-thumb-layout">
              <QueuePanelThumbItem
                v-for="panel of tougheningBedPanelList"
                :key="panel.id"
                :panel="panel"
                :removeEnabled="false"
                :currentStationId="productionStation.id"
                :queueDisplayType="productionStation.queueDisplayType"
                :highlightColour="productionStage.highlightColour"
                :ref="`panel-queue-${panel.id}`"
                @previewClicked="queuePanelPreviewClicked($event, panel)"
                @panelClicked="queuePanelClicked($event, panel)"
                >
              </QueuePanelThumbItem>
            </div>
            <h2 class="text-muted text-center" v-if="tougheningBedPanelList.length == 0">No panels in toughening</h2>
          </div>
        </template>
      </div>
      
    </div>

    <div class="furnace-bed-list">
      <FurnaceBedList
        :bedList="furnaceBedList"
        :currentBedIndex="currentBedIndex"
        :canControlBeds="true"
        :advancedBedDisabled="submittingAdvanceBed"
        @bedClick="currentBedIndex = $event"
        @advanceBed="advanceLoadingBed" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.toughening-view-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
}
.furnace-main-view {
  flex: 82%;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.furnace-view {
  padding: 1.5rem !important;
  flex: 100%;
  display: flex;
  flex-direction: column;
  align-items:stretch;
}
.furnace-bed-list {
  flex: 18%;
}
.furnace-options {
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

</style>


<script>
import _ from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'

import formMixin from '@/mixins/form'
import Utils from '@/utils/utils'
import EventBus from '@/utils/eventBus'

import productionStationMixin from '@/apps/glass-production-station/src/mixins/productionStation'

import StationControlPanelButton from '@/apps/glass-production-station/src/components/buttons/stationControlPanelButton'
import StationAlertMessage from '@/apps/glass-production-station/src/components/station/stationAlertMessage'
import QueuePanelListItem from '@/apps/glass-production-station/src/components/station/queuePanelListItem'
import QueuePanelThumbItem from '@/apps/glass-production-station/src/components/station/queuePanelThumbItem'

import TougheningBatchBar from '@/apps/glass-production-station/src/components/station/tougheningBatchBar'
import FurnaceBedList from '@/apps/glass-production-station/src/components/station/furnaceBedList'

import TougheningBatchDialog from '@/apps/glass-production-station/src/views/tougheningBatchDialog'
import FastForwardCompleteDialog from '@/apps/glass-production-station/src/views/fastForwardCompleteDialog'
import StationScanWarningDialog from '@/apps/glass-production-station/src/views/stationScanWarningDialog'

import { AccountSettingKeys, ProductionStationTypes, LinkTypes, ToughenBatchGlassTypes, ToughenBatchGlassTypeLookup, StockFaceLayerTypes, StockFaceLayerTypeLookup, ToughenBatchComplianceTypes, ProductionStationQueueDisplayTypes } from '@/store/types'

export default {
  name: 'TougheningStationView',
  mixins: [formMixin, productionStationMixin],
  components: {
    StationControlPanelButton,
    StationAlertMessage,
    QueuePanelListItem,
    QueuePanelThumbItem,
    TougheningBatchBar,
    FurnaceBedList
  },
  props: {
    productionStage: Object,
    productionStation: Object
  },
  data() {
    return { 
      barcodeEntry: '',
      panelScanSuccess: false,
      panelScanError: false,
      panelDetails: {
        barcode: '',
        nextStage: '',
        nextStageColour: '#400000',
        tasksComplete: false,
        despatchType: '',
        panelTaskStarted: false,
        panelTaskCompleted: false,
      },
      currentBedIndex: 0,
      panelScanErrorMessage: '',
      submittingAdvanceBed: false
    }
  },
  computed: {
    ...mapState({
      accountSettings: state => state.account.accountSettings
    }),
    isLoadingBedSelected() {
      return this.currentBedIndex == 0
    },
    isWaitingBatchBedSelected() {
      return this.currentBedIndex == 1
    },
    isTougheningBedSelected() {
      return this.currentBedIndex == 2
    },
    scanInAvailable() {
      return !this.isStationFurnanceUnloadType && this.productionStation.isScanInAvailable
    },
    scanOutAvailable() {
      return this.productionStation.isScanOutAvailable
    },
    loadBedPanelList() {
      return this.getPanelsAtFurnaceBed(0)
    },
    waitingBatchBedPanelList() {
      return this.getPanelsAtFurnaceBed(1)
    },
    tougheningBedPanelList() {
      return this.getPanelsAtFurnaceBed(2)
    },
    selectedBedSampleCount() {
      return this.getSampleCountAtFurnaceBed(this.currentBedIndex)
    },
    isStationFurnanceUnloadType() {
      return this.productionStation.type == ProductionStationTypes.furnaceUnload
    },
    isTougheningBatchValid() {
      if(!this.productionStation.tougheningBatch)
        return false

      // Expired?
      if(moment().isAfter(moment(this.productionStation.tougheningBatch.expiryTime)))
        return false

      return true
    },
    isTougheningBatchInGracePeriod() {
      if(!this.productionStation.tougheningBatch)
        return false

      // Expired?
      if(moment().isAfter(moment(this.productionStation.tougheningBatch.expiryTime)) && moment().isBefore(moment(this.productionStation.tougheningBatch.expiryTime).add(this.batchExpiryGraceTime, 'minutes')))
        return true

      return false
    },
    batchExpiryGraceTime() {
      if(!this.accountSettings)
        return false

      return parseInt(this.accountSettings[AccountSettingKeys.productionTougheningBatchGraceTime] || 0)
    },
    displayWaitingBed() {
      if(this.waitingBatchBedPanelList.length > 0 || !this.isTougheningBatchValid)
        return true

      return false
    },
    furnaceBedList() {
      var loadingCount = this.loadBedPanelList.length
      var waitingCount = this.waitingBatchBedPanelList.length
      var tougheningCount = this.tougheningBedPanelList.length

      // Get sample piece data from station data
      var stationProcessingData = this.productionStation.stationProcessingData || {}
      var sampleList = stationProcessingData.furnaceSampleList || []

      var loadingBedYield = 0
      if(this.productionStation && _.isObject(this.productionStation.furnaceConfig)) {
        var bedArea = this.productionStation.furnaceConfig.bedWidth * this.productionStation.furnaceConfig.bedHeight
        var panelArea = this.loadBedPanelList.reduce((curValue, panel) => curValue + (panel.panelWidth * panel.panelHeight), 0)

        if(bedArea > 0 && panelArea > 0)
          loadingBedYield = Math.round((panelArea / bedArea) * 100.0)
      }

      return _.compact([
        { index: 0, name: 'Loading', panelCount: loadingCount, hasSamplePiece: sampleList.some(sampleInfo => sampleInfo.bedIndex == 0), yieldPercent: loadingBedYield },
        this.displayWaitingBed ? { index: 1, name: 'Waiting Batch', panelCount: waitingCount, hasSamplePiece: sampleList.some(sampleInfo => sampleInfo.bedIndex == 1) } : null,
        { index: 2, name: 'Unloading', panelCount: tougheningCount, hasSamplePiece: sampleList.some(sampleInfo => sampleInfo.bedIndex == 2) },
      ])
    },
    isStationQueueEditorView() {
      if(this.productionStation)
        return this.productionStation.queueDisplayType == ProductionStationQueueDisplayTypes.editorView
      return false
    },
    isStationQueueThumbView() {
      if(this.productionStation)
        return this.productionStation.queueDisplayType == ProductionStationQueueDisplayTypes.smallThumbnail || this.productionStation.queueDisplayType == ProductionStationQueueDisplayTypes.largeThumbnail
      return false
    }
  },
  watch: {
    'currentBedIndex': function(newValue) {
      this.$refs.alertMessage.hide()
      this.barcodeEntry = ''

      this.$nextTick(() => {
        this.$refs.panelBarcodeScan.focus()
      })
    },
    'productionStation.productionPanels': {
      handler: function(newVal, oldVal) {
        // Only scroll down if new panels added
        if(newVal && oldVal && this.isLoadingBedSelected) {
          if(newVal.length > oldVal.length) {
            this.$nextTick(() => {
              this.loadingQueueListUpdated()
            })
          }
        }
      }
    }
  },
  mounted() {
    this.$refs.panelBarcodeScan.select()
    this.$refs.panelBarcodeScan.focus()

    EventBus.on(EventBus.EventTypes.panelLabelPrinted, this.focusBarcodeEntry)
  },
  beforeDestroy() {
    EventBus.off(EventBus.EventTypes.panelLabelPrinted, this.focusBarcodeEntry)
  },
  methods: {
    onScannedBarcode() {
      if(this.barcodeEntry.trim().length == '') {
        this.barcodeEntry = ''
        return
      }

      // If not on the loading bed or loading has items, just run normal panel scan
      if(!this.isLoadingBedSelected || this.loadBedPanelList.length > 0 || this.getSampleCountAtFurnaceBed(0) > 0) {
        this.runPanelScan(this.barcodeEntry)
        return
      }

      // If on the loading bed, run some initial tests to check if we need to confirm or start a new batch/sample
      this.$apiService.glassProductionStationService.runBarcodeLookup(this.productionStation.id, this.barcodeEntry)
      .then(response => {
        // Reset
        this.barcodeEntry = ''

        if(response.data.model != LinkTypes.productionPanel) {
          this.$refs.alertMessage.displayAlert('error', 'Scanning Error!', 'Barcode must be associated with a panel')
          return
        }

        this.runPanelLoadingChecks(response.data.data)
        .then(result => {          
          if(result.isConfirmed)
            this.runPanelScan(response.data.barcode)
          else if(result.isDenied)
            this.createBatchSample()          
        })
      })
      .catch(err => {
        // Reset
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
        
        let errorInfo = this.processFormResponse(err)
        this.$refs.alertMessage.displayAlert('error', 'Scanning Error!', errorInfo.errorMessage)
      })
    },
    runPanelScan(barcode, options = {}) {
      // Setup scan info based on bed selected
      var scanData = {
        barcode: barcode
      }
      if(this.isLoadingBedSelected)
        scanData.isStartingOnly = 1
      if(this.isTougheningBedSelected)
        scanData.isCompletingOnly = 1

      if(options)
        scanData = _.merge(scanData, options)

      // Run the scan in/out function on the panel scanned
      this.$apiService.glassProductionStationService.runPanelBarcodeScan(this.productionStation.id, scanData)
      .then(response => {
        this.$refs.alertMessage.hide()

        let barcode = response.data.panelBarcode
        var nextStage = ''

        if(response.data.panelTaskCompleted) {
          if(response.data.nextStage && response.data.nextStage.productionStage) {
            nextStage = response.data.nextStage.productionStage.name
          }
        }

        if(response.data.tasksComplete) {
          var despatchName = response.data.despatchTaskType ? response.data.despatchTaskType.name : ''
          this.$refs.alertMessage.displayAlert('success', 'Panel Completed', `Panel ${barcode} has finished processing and is due at <strong>despatch</strong> for <strong>${despatchName}</strong>`)
        } else {
          if(response.data.panelTaskStarted)
            this.$refs.alertMessage.displayAlert('success', 'Panel Scanned In', `Panel ${barcode} added`)
          else if(response.data.panelTaskCompleted)
            this.$refs.alertMessage.displayAlert('success', 'Panel Scanned Out', `Panel ${barcode} is next due at <strong>${nextStage}</strong>`)
        }

        // Back to scanning
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
      })
      .catch(err => {
        let errorInfo = this.processFormResponse(err)

        this.$refs.alertMessage.hide()

        // If the server requested a new toughening batch be started, run that process
        if(errorInfo.errorData && errorInfo.errorData.requestTougheningBatch) {
          let scannedPanelThickness = parseFloat(errorInfo.errorData.panelThickness)

          // Start new toughening batch
          this.displayModal(TougheningBatchDialog, { 
            productionStageId: this.productionStage.id,
            productionStationId: this.productionStation.id,
            panelThickness: scannedPanelThickness
          })
          .then((success) => {
            if(success) {
              // Info - Toughening Batch Created, ready to scan panels
              this.$refs.alertMessage.displayAlert('success', 'Batch Created', 'New toughening batch created')

              // Refresh to show batch bar
              this.$emit('refreshStation')

              // Attempt to automatically scan in the panel again now we have a valid toughening batch
              this.$nextTick(() => {
                this.onScannedBarcode()
              })
              
            } else {
              // Back to scanning
              this.barcodeEntry = ''
              this.$refs.panelBarcodeScan.focus()
            }
          })          
          return
        }

        // If the server gives fast forward options, display the fast forward dialog
        if(errorInfo.errorData && errorInfo.errorData.fastForwardOptions && errorInfo.errorData.fastForwardOptions.available) {

          // Show fast forward complete options
          this.displayModal(FastForwardCompleteDialog, { 
            productionStageId: this.productionStage.id,
            productionStationId: this.productionStation.id,
            fastForwardOptions: errorInfo.errorData.fastForwardOptions,
          })
          .then((result) => {
            if(result != null) {


              if(result.allTasksCompleted) {
                // Attempt to automatically scan in the panel again now we have completed all pending tasks
                this.$nextTick(() => {
                  this.onScannedBarcode()
                })
                return
              } else {
                this.$refs.alertMessage.displayAlert('success', 'Tasks Completed', 'Pending Tasks completed, ready for scanning')
              }
            }

            // Back to scanning
            this.barcodeEntry = ''
            this.$refs.panelBarcodeScan.focus()
          })          
          return
        }

        // If the server gives warnings + override, display the override warning dialog
        if(errorInfo.errorData && errorInfo.errorData.overrideWarningOptions && errorInfo.errorData.overrideWarningOptions.available) {

          // Show warning override options
          this.displayModal(StationScanWarningDialog, { 
            productionStageId: this.productionStage.id,
            productionStationId: this.productionStation.id,
            overrideWarningOptions: errorInfo.errorData.overrideWarningOptions,
          })
          .then((result) => {

            if(result) {
              // Attempt to scan again with override specified
              this.$nextTick(() => {
                this.runPanelScan(barcode, { overrideWarnings: true, overrideName: result.name })
              })
            }
          })          
          return
        }

        this.$refs.alertMessage.displayAlert('error', 'Scanning Error!', errorInfo.errorMessage)
        
        // Back to scanning
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
      })

    },
    removePanelFromStation(productionPanelId) {
      // Remove panel
      this.$apiService.glassProductionStationService.removePanelFromStation(this.productionStation.id, { productionPanelId: productionPanelId })
      .then(response => {
        this.$refs.alertMessage.hide()

        this.$refs.panelBarcodeScan.select()
      })
      .catch(err => {
        let errorInfo = this.processFormResponse(err)
        this.$refs.alertMessage.displayAlert('error', 'Error Removing Panel!', errorInfo.errorMessage)

        // Back to scanning
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
      })
    },

    advanceLoadingBed(sourceBedIndex) {
      // Check if advancing to waiting bed or straight to unloading
      var destBedIndex = sourceBedIndex + 1
      if(!this.displayWaitingBed)
        destBedIndex++

      this.confirmMessage('Advance Furnace Bed?', 'This will push all the panels / samples into the next bed')
      .then(success => {
        if(success) {
          var advanceData = {
            sourceBedIndex: sourceBedIndex,
            destBedIndex: destBedIndex
          }

          this.submittingAdvanceBed = true
          this.$apiService.glassProductionStationService.advanceTougheningBed(this.productionStation.id, advanceData)
          .then(response => {
            let panelList = response.data
            this.$refs.alertMessage.displayAlert('success', 'Bed Advanced', `Panels / Samples have been advanced into the next bed`)

            // If the destination is the final bed, download the list of labels for printing
            // The desktop app will intercept & send to printer
            if(destBedIndex == 2 && panelList.length > 0) {
              this.requestPanelLabelDownload(panelList.map(panel => panel.id))
            }

            // Refresh to update counts & panel lists
            this.$emit('refreshStation')
          })
          .catch(err => {
            let errorInfo = this.processFormResponse(err)

            // Check if new toughening batch requested
            if(errorInfo.errorData && errorInfo.errorData.requestTougheningBatch) {
              let scannedPanelThickness = parseFloat(errorInfo.errorData.panelThickness)

              // Start new toughening batch
              this.displayModal(TougheningBatchDialog, { 
                productionStageId: this.productionStage.id,
                productionStationId: this.productionStation.id,
                panelThickness: scannedPanelThickness
              })
              .then((success) => {
                if(success) {
                  // Info - Toughening Batch Created, ready to scan panels
                  this.$refs.alertMessage.displayAlert('info', 'Batch Created', 'New toughening batch created, ready to advance furnace')

                  // Refresh to show batch bar
                  this.$emit('refreshStation')
                }

                // Back to scanning
                this.barcodeEntry = ''
                this.$refs.panelBarcodeScan.focus()
              })          
              return
            }
              
            this.$refs.alertMessage.displayAlert('error', 'Toughening Error!', errorInfo.errorMessage)
          })
          .finally(() => {
            this.submittingAdvanceBed = false
          })
        }
      })
    },

    getPanelsAtFurnaceBed(furnaceBedIndex) {
      return this.productionStation.productionPanels.filter(panel => {
        return panel.stationData && parseInt(panel.stationData.furnaceBedIndex) == furnaceBedIndex
      })
    },
    getSampleCountAtFurnaceBed(furnaceBedIndex) {
      var stationProcessingData = this.productionStation.stationProcessingData || {}
      var sampleList = stationProcessingData.furnaceSampleList || []

      return sampleList.filter(sampleInfo => sampleInfo.bedIndex == furnaceBedIndex).length
    },

    queuePanelClicked(event, panel) {
      let panelComponent = this.$refs[`panel-queue-${panel.id}`][0]
      this.$emit('panelClick', { panel: panel, target: panelComponent.$el, forceElement: true })
    },
    queuePanelPreviewClicked(event, panel) {
      let panelComponent = this.$refs[`panel-queue-${panel.id}`][0]

      this.$emit('panelPreviewClick', { panel: panel, target: panelComponent.$el, forceElement: true })
    },
    focusBarcodeEntry() {
      // Ignore if a modal dialog if open
      if(this.isDocumentModalVisible())
        return

      this.$refs.panelBarcodeScan.select()
    },

    tougheningBarClicked() {
      this.createNewBatch()      
    },
    createNewBatch() {
      // Start new toughening batch
      this.displayModal(TougheningBatchDialog, { 
        productionStageId: this.productionStage.id,
        productionStationId: this.productionStation.id
      })
      .then((success) => {
        if(success) {
          // Info - Toughening Batch Created, ready to scan panels
          this.$refs.alertMessage.displayAlert('info', 'Batch Created', 'New toughening batch created')

          // Refresh to show batch bar
          this.$emit('refreshStation')
        }

        // Back to scanning
        this.barcodeEntry = ''
        this.$refs.panelBarcodeScan.focus()
      })          
    },

    newSampleButtonClicked() {
      this.confirmMessage('Create Sample Piece?', 'This will create a sample piece on the bed for toughening testing. Continue?')
      .then(success => {
        if(success) {
          this.createBatchSample()
        }
      })
    },
    createBatchSample() {
      // Setup sample in the toughening station data
      // Run on source stations if this is unload station
      var sourceStationId = this.productionStation.id
      if(this.productionStation.sourceProductionStations && this.productionStation.sourceProductionStations.length > 0)
        sourceStationId = this.productionStation.sourceProductionStations[0].id

      var stationProcessingData = this.productionStation.stationProcessingData || {}
      var sampleList = stationProcessingData.furnaceSampleList || []

      if(!sampleList.some(sampleInfo => sampleInfo.bedIndex == 0))
        sampleList.push({ bedIndex: 0 })

      stationProcessingData.furnaceSampleList = sampleList

      this.$apiService.glassProductionStationService.updateStationProcessingData(sourceStationId, { stationProcessingData: stationProcessingData })
      .then(response => {
        this.$emit('refreshStation')

        this.$refs.alertMessage.displayAlert('success', 'Sample Added', 'New sample piece added to the loading bed')
      })
      .catch(err => {
        let errorInfo = this.processFormResponse(err)
        this.$refs.alertMessage.displayAlert('error', 'Error!', errorInfo.errorMessage)
      })
    },
    removeBatchSample() {
      this.confirmMessage('Remove Sample Piece?', 'This will remove the sample piece from the current bed. Continue?')
      .then(success => {
        if(success) {
          // Setup sample in the toughening station data
          // Run on source stations if this is unload station
          var sourceStationId = this.productionStation.id
          if(this.productionStation.sourceProductionStations && this.productionStation.sourceProductionStations.length > 0)
            sourceStationId = this.productionStation.sourceProductionStations[0].id

          var stationProcessingData = this.productionStation.stationProcessingData || {}
          var sampleList = stationProcessingData.furnaceSampleList || []

          sampleList = sampleList.filter(sampleInfo => sampleInfo.bedIndex != this.currentBedIndex)
          stationProcessingData.furnaceSampleList = sampleList

          this.$apiService.glassProductionStationService.updateStationProcessingData(sourceStationId, { stationProcessingData: stationProcessingData })
          .then(response => {
            this.$emit('refreshStation')

            this.$refs.alertMessage.displayAlert('success', 'Sample Removed', 'Sample piece removed from the current bed')
          })
          .catch(err => {
            let errorInfo = this.processFormResponse(err)
            this.$refs.alertMessage.displayAlert('error', 'Error!', errorInfo.errorMessage)
          })
        }
      })
    },

    async runPanelLoadingChecks(productionPanel) {
      // Run checks after a production panel was scanned onto the loading bed
      // If there are mismatches in configuration, display a warning message

      var messageText = null

      if(!this.isTougheningBatchValid && !this.isTougheningBatchInGracePeriod)
        messageText = 'The current toughening batch has expired'
      else {
        // Compare panel to the toughening batch
        var batch = this.productionStation.tougheningBatch
        var panelStock = productionPanel.orderItem.stock

        var panelBatchGlassType = ToughenBatchGlassTypes.standard
        if(panelStock.isStockUsingFaces && panelStock.faceLayerType == StockFaceLayerTypes.pattern)
          panelBatchGlassType = ToughenBatchGlassTypes.pattern
        else if(panelStock.isStockUsingFaces && panelStock.faceLayerType == StockFaceLayerTypes.coated)
          panelBatchGlassType = ToughenBatchGlassTypes.coated

        if(Math.abs(batch.batchThickness - panelStock.thickness) >= 1.0)
          messageText = `The current batch has a different thickness (${batch.batchThickness}mm)`
        else if(panelBatchGlassType != batch.glassType)
          messageText = `The current batch has a different glass type (${this.formatLookupName(batch.glassType, ToughenBatchGlassTypeLookup)}) to the panel (${this.formatLookupName(panelStock.faceLayerType, StockFaceLayerTypeLookup)})`
        else if(batch.complianceType == ToughenBatchComplianceTypes.automotive)
          messageText = `The current batch is an automotive compliance type`
      }

      // Let the panel through if no issue was detected
      if(!messageText)
        return Promise.resolve({ isConfirmed: true })

      return this.displayCustomMessageBox('Batch Mismatch', `${messageText}. Confirm scan in?`, {
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        denyButtonText: 'New Sample',
        customClass: {
          actions: 'my-actions',
          cancelButton: 'order-1 right-gap',
          confirmButton: 'order-2',
          denyButton: 'order-3',
        },
      })
      .then(result => {
        return Promise.resolve(result)
      })
      .catch(err => {
        return Promise.reject(err)
      })
    },
    loadingQueueListUpdated() {
      // Scroll to the last panel scanned
      if((this.isStationQueueEditorView || this.isStationQueueThumbView) && this.$refs.loadingQueueList) {
        this.$refs.loadingQueueList.scrollTo({ top: this.$refs.loadingQueueList.scrollHeight, behavior: 'smooth' })
      }
    },

    scanOptionsClicked() {
      this.displayStationScanOptions(this.productionStation.id)
    }
  }
  
}
</script>